import React, {Fragment, useContext} from "react";
import {ServerContext} from "../../serverContext/ServerProvider";
import {NotificatorContext} from "../Notificator";
import {ResetContext} from "./ResetContext";

export const Reset = () => {
    const {reset} = useContext(ServerContext)
    const {showNotification} = useContext(NotificatorContext)
    const {stopTimer, visible, timeLeft} = useContext(ResetContext)

    const clickHandler = () => {
        stopTimer()
        reset(() => showNotification('Successful reset, update the page'))
    }

    const transformToString = () => {
        return Math.trunc(timeLeft / 60) + ':' + (timeLeft % 60)
    }

    return (
        <Fragment>
            <button
                className='btn btn-danger reset_button'
                onClick={clickHandler}
            >
                RESET
            </button>
            {visible?(
                <h5 className='reset_timer'>{transformToString()}</h5>
            ):''}
        </Fragment>
    )
}